exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-card {\n  margin-bottom: 1rem;\n  padding: 0 !important; }\n\nmat-card {\n  padding: 0 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/components/bot-summary/bot-summary.component.scss
// module id = ../../../../../src/app/components/bot-summary/bot-summary.component.scss
// module chunks = main